import baseBackendApi from "../main/configuration/baseBackendApi";

export const getSongRequests = async () => {
  const response = await baseBackendApi.get("songrequest/admin");
  return response.data;
};
